export default "__VITE_ASSET__CfOMmz85__"